import { useQuery } from '@tanstack/react-query';
import { Heart } from 'lucide-react';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { StoryGuest } from '@/shared/api';
import { storyByIdQueryOptions } from '@/shared/queries';
import { cn } from '@/shared/utils';

import { BaseHeader } from './base-header';
import { SidebarLayout } from './sidebar-layout';

type GuestLayoutProps = {
  children: ReactNode;
  storyId: string;
};

export const GuestLayout = ({ children, storyId }: GuestLayoutProps) => {
  const intl = useIntl();
  const query = useQuery(storyByIdQueryOptions(storyId));

  const story = query.data?.data as unknown as StoryGuest | undefined;

  return (
    <SidebarLayout>
      <BaseHeader>
        {story?.author && (
          <div
            className={cn('flex gap-1 opacity-0 transition-opacity duration-1000', {
              'opacity-100': story?.author,
            })}
          >
            <span>
              {intl.formatMessage(
                { id: 'story.withLove' },
                {
                  author: story?.author,
                  b: (msg) => <b>{msg}</b>,
                },
              )}
            </span>

            <span>
              <Heart fill="red" />
            </span>
          </div>
        )}
      </BaseHeader>

      <div className="min-h-[100vh]">{children}</div>
    </SidebarLayout>
  );
};
